import { useCallback, useState } from 'react';

import { find } from 'lodash-es';

import { AnyFilterItem } from '@components/Filter/buildGridifyQuery/types';

export const useFiltersWithTextSearch = () => {
  const [filters, onFiltersChange] = useState<AnyFilterItem[]>([]);
  const [textSearchValue, onTextSearchChange] = useState<string>('');

  const getValueByFilterItemKey = useCallback(
    (key: string) => {
      const filterItems = find(filters, ['key', key]);

      return filterItems ? filterItems.value : [];
    },
    [filters],
  );

  return {
    filters,
    onFiltersChange,
    textSearchValue,
    onTextSearchChange,
    getValueByFilterItemKey,
  };
};
